import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';

const LazyImage = ({
  className,
  src,
  loadedCallback,
  errorCallback,
  ...rest
}) => {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    rootMargin: '100%',
  });

  // If we're in view and have the IntersectionObserver already
  if (inView) {
    return (
      <img
        className={className}
        src={src}
        ref={inViewRef}
        loading="lazy"
        onLoad={loadedCallback ? () => loadedCallback() : null}
        onError={errorCallback ? () => errorCallback() : null}
        {...rest}
      />
    );
  } else {
    return (
      <div className={className} ref={inViewRef}>
        <noscript>
          <img src={src} loading="lazy" {...rest} />
        </noscript>
      </div>
    );
  }
};

export default React.memo(LazyImage);
